import {KpiVI} from "./kpi/vi";

export const evaluationKpiVI = {
    "evaluation-kpi": "Đánh giá KPI",
    "evaluation": "KPI",
    ...KpiVI
}